import {changeFilteredInfo} from "@/utils/data/tableCol/tableUtils";

export const techData = (filteredInfos) => {
    let filteredInfo = changeFilteredInfo(filteredInfos)
    return [
        {
            title: '资料名称',
            dataIndex: 'reportName',
            key: 'reportName',
            scopedSlots: {
                filterDropdown: 'filterDropdown',
                filterIcon: 'filterIcon',
                filtered: true,
            },
            filteredValue: filteredInfo.reportName || [],
        },
        {
            title: '分类1',
            dataIndex: 'classificationOne',
            key: 'classificationOne'
        },
        {
            title: '分类2',
            dataIndex: 'classificationTwo',
            key: 'classificationTwo'
        },
        {
            title: '维护人',
            dataIndex: 'maintainers',
            key: 'maintainers',
            scopedSlots: {
                filterDropdown: 'filterDropdown',
                filterIcon: 'filterIcon',
                filtered: true,
            },
            filteredValue: filteredInfo.maintainers || [],
        },
        {
            title: '文件大小',
            dataIndex: 'size',
            key: 'size'
        },
        {
            title: '文件更新时间',
            dataIndex: 'updateTime',
            key: 'updateTime'
        },
        {
            title: '操作',
            key: 'operation',
            scopedSlots: {customRender: 'operation'},
            width: 150
        }
    ]
}
